@if (hasDashboardSearches$ | async) {
  <app-search-dashboard></app-search-dashboard>
} @else {
  <div class="container" #empty>
    <app-logo-svg logo-size="256" monochrome></app-logo-svg>
  </div>
}
